import React from "react";
import { Col, Form } from "antd";
import {
  FullHeightRow,
  StyledButton,
  StyledInput,
  StyledLink,
  StyledPasswordInput,
} from "../../components/styledComponent/styledElements";
import { AiOutlineUser } from "react-icons/ai";
import { MdPassword } from "react-icons/md";
import loginLogo from "../../assets/images/Logo.svg";
import { useNavigate } from "react-router-dom";
function SignUp() {
  const navigate = useNavigate();
  return (
    <FullHeightRow className="space-around login-page">
      <Col span={8} className="login-div">
        <Form className="loginForm">
          <div className="mb-2">
            <img src={loginLogo} alt="partspal logo" />
          </div>
          <Form.Item>
            <StyledInput
              placeholder="Enter your username"
              prefix={
                <AiOutlineUser
                  style={{
                    color: "rgba(0,0,0,.25)",
                  }}
                />
              }
            />
          </Form.Item>
          <Form.Item>
            <StyledPasswordInput
              prefix={<MdPassword style={{ color: "rgba(0,0,0,.25)" }} />}
              placeholder="Enter your password"
            />
          </Form.Item>
          <Form.Item>
            <StyledPasswordInput
              prefix={<MdPassword style={{ color: "rgba(0,0,0,.25)" }} />}
              placeholder="Confirm password"
            />
          </Form.Item>
          <StyledButton className="mt-6">Signup</StyledButton>
          <div className="text-center mt-2">
            <p>
              Already have an account?
              <span onClick={() => navigate("/login", { replace: true })}>
                <StyledLink>Login</StyledLink>
              </span>
            </p>
          </div>
        </Form>
      </Col>
    </FullHeightRow>
  );
}

export default SignUp;
